export default "__VITE_ASSET__CjQM31vB__"